import { render, staticRenderFns } from "./RoomTemplatesText.vue?vue&type=template&id=1c465346&"
import script from "./RoomTemplatesText.vue?vue&type=script&lang=js&"
export * from "./RoomTemplatesText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports